import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="SmeContactBox contentbox contentbox--white">
            <h2 class="title-2 SmeContactBox__title">{{ title }}</h2>

            <div v-if="content" class="SmeContactBox__content" v-html="content"></div>

            <div v-if="button || button2 || button3" class="SmeContactBox__buttons">
                <button v-if="button2" type="button" class="button button--primary button--full" @click="$emit('click:button2')">{{ button2_label }}</button>

                <a v-if="button" :href="button_link" class="button button--secondary button--full" @click="$emit('click:button', $event)">{{ button_label }}</a>

                <button v-if="button3" type="button" class="button button--secondary button--full" @click="$emit('click:button3')">{{ button3_label }}</button>
            </div>
        </div>
    `,

    emits: [
        'click:button',
        'click:button2',
        'click:button3',
    ],

    props: {
        title: { type: String, default: 'Jesteśmy tu, by Ci pomóc!' },
        content: { type: String, default: 'Masz pytania albo potrzebujesz pomocy w podjęciu decyzji? Porozmawiaj z naszym Doradcą.' },

        button: { type: Boolean, default: true },
        button_link: { type: String, default: '/dla-firm/formularz-kontaktowy' },
        button_label: { type: String, default: 'Kontakt z doradcą' },

        button2: { type: Boolean },
        button2_label: { type: String, default: 'Sprawdź ofertę' },

        button3: { type: Boolean, default: false },
        button3_label: { type: String, default: 'Kontakt z doradcą' },
    },
});
